import React from "react";
import {
  Box,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export default function DebugPanel({ title = "Debug", data }) {
  if (process.env.NODE_ENV !== "development") return null;

  return (
    <Box sx={{ mt: 4 }}>
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant="body2" sx={{ fontWeight: 600 }}>
            🐛 {title}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Box
            component="pre"
            sx={{
              whiteSpace: "pre-wrap",
              fontSize: 13,
              backgroundColor: "#f4f4f4",
              p: 2,
              borderRadius: 2,
              overflowX: "auto",
              maxHeight: 400,
            }}
          >
            {JSON.stringify(data, null, 2)}
          </Box>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
}
